module.exports = __webpack_public_path__ + "static/media/siddharth-naidu.9974fdfa.png";